import service from "./service";

async function setLanguage() {
  try {
    const res = await service.setLanguage();
    return res;
  } catch (error) {
    return null;
  }
}

async function getCurrentUser() {
  try {
    const res = await service.getCurrentUser();
    return res;
  } catch (error) {
    return null;
  }
}

async function getProfile() {
  try {
    const res = await service.getProfile();
    return res;
  } catch (error) {
    return null;
  }
}

async function getJobSeekers(payload) {
  try {
    const res = await service.getJobSeekers(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getUserList(payload) {
  try {
    const res = await service.getUserList(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function updateUserRole(payload) {
  try {
    const res = await service.updateUserRole(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function updateUserStatus(payload) {
  try {
    const res = await service.updateUserStatus(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function deleteUser(payload) {
  try {
    const res = await service.deleteUser(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function inviteUser(payload) {
  try {
    const res = await service.inviteUser(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function initPassword(payload) {
  try {
    const res = await service.initPassword(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function register(payload) {
  try {
    const res = await service.register(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function updatePassword(payload) {
  try {
    const res = await service.updatePassword(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function join(payload) {
  try {
    const res = await service.join(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function findAccount(payload) {
  try {
    const res = await service.findAccount(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function resetPassword(payload) {
  try {
    const res = await service.resetPassword(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function certifiedMyInfo(payload) {
  try {
    const res = await service.certifiedMyInfo(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function myInfoPasswordChange(payload) {
  try {
    const res = await service.myInfoPasswordChange(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function myInfoSettingChange(payload) {
  try {
    const res = await service.myInfoSettingChange(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function myInfoUserDelete(payload) {
  try {
    const res = await service.myInfoUserDelete(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function myInfoUpdateUser(payload) {
  try {
    const res = await service.myInfoUpdateUser(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function myInfoPaymentsList(payload) {
  try {
    const res = await service.myInfoPaymentsList(payload);
    return res;
  } catch (error) {
    return null;
  }
}
// 상세 정산내역 다운로드
function getPaymentDetailExcel(payload) {
  return new Promise((resolve, reject) => {
    service
      .getPaymentDetailListExcel(payload)
      .then((res) => {
        const name = `${payload.participantName}`;
        const ext = `.${payload.fileType}`;
        const filename = name + ext;
        const result = downloadExcel(res, filename);
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
function downloadExcel(res, filename) {
  const blob = new Blob([res.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  link.style.cssText = "display: none";
  document.body.appendChild(link);
  link.click();
  link.remove();
}
export default {
  setLanguage,
  getCurrentUser,
  getJobSeekers,
  getUserList,
  updateUserRole,
  updateUserStatus,
  deleteUser,
  inviteUser,
  initPassword,
  register,
  updatePassword,
  getProfile,
  join,
  findAccount,
  resetPassword,
  certifiedMyInfo,
  myInfoPasswordChange,
  myInfoSettingChange,
  myInfoUserDelete,
  myInfoUpdateUser,
  myInfoPaymentsList,
  getPaymentDetailExcel,
};
